import { Outlet } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import Header from "./Header";
import Footer from "./Footer";

export default function PublicLayout() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
  }, []);
  const ctx = useMemo(() => ({ settings }), [settings]);
  return (
    <div className="relative min-h-screen bg-[#000000] text-white">
      <div className="ambient-bg" />
      <Header settings={settings} />
      <main className="relative z-10">
        <Outlet context={ctx} />
      </main>
      <Footer settings={settings} />
    </div>
  );
}
